import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/registro_marca/estatus';
import EstatusList from './EstatusList';


const ms2p = (state) => {
  return {
    ...state.estatus_rm,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(EstatusList);
